<template>
	<div :class="$style['stat-item']">
		<div :class="[$style['stat-item__value'], colorClass && $style[colorClass]]" data-stat-value>
			<slot />
		</div>
		<span :class="$style['stat-item__caption']">{{ label }}</span>
	</div>
</template>

<script>
export default {
	name: 'StatItem',
	props: {
		label: {
			type: String,
			default: null
		},
		color: {
			type: String,
			default: null,
			validator: (v) => ['success', 'danger', 'warning'].includes(v)
		}
	},
	computed: {
		colorClass () {
			return this.color ? `stat-item__value--${this.color}` : null
		}
	}
}
</script>

<style module lang="scss">
.stat-item {
    display: flex;
    flex-direction: column;
    min-width: 100px;
    box-sizing: border-box;

    &__value {
        font-size: 16px;
        font-weight: bold;
        color: getColor(text);

        &--success {
            color: getColor(success);
        }

        &--danger {
            color: getColor(danger);
        }

        &--warning {
            color: getColor(warning);
        }
    }

    &__caption {
        font-size: 12px;
        color: getColor(caption);
        margin-top: 4px;
    }
}
</style>

<style lang="scss">
[data-stat-value] {
    a {
        color: inherit;
        font-weight: inherit;
        cursor: pointer;

        &:hover {
            color: getColor(primary);
        }
    }
}
</style>
